const areSameContactLenses = (serverLineItem, draftLineItem) => {
  if (draftLineItem.type !== "contact-lenses" || serverLineItem.typeDetails?.__typename !== "ContactLensesTypeDetails") {
    return false;
  }
  return serverLineItem.sku === draftLineItem.sku && serverLineItem.typeDetails?.eyeSide === draftLineItem.typeDetails.eyeSide?.toUpperCase();
};
export {
  areSameContactLenses
};
//# sourceMappingURL=are-same-contact-lenses.js.map
